export default __webpack_public_path__ + "assets/shot-chart-court-bg-e6feab5218a6d2c5d6bfd1720c5ccd44.jpg";